/** localStorage for trade-in contact form (/tradeincontact). */
export const TRADEIN_CONTACT_STORAGE_KEY = 'ploomsurvey:tradeinContact';

export type TradeInContactAnswers = {
  mobileLocalDigits: string;
  name: string;
  email: string;
};

export function readTradeInContactAnswers(): TradeInContactAnswers | null {
  try {
    const raw = localStorage.getItem(TRADEIN_CONTACT_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const mobileLocalDigits = (o as { mobileLocalDigits?: unknown }).mobileLocalDigits;
    const name = (o as { name?: unknown }).name;
    const email = (o as { email?: unknown }).email;
    if (typeof mobileLocalDigits !== 'string') return null;
    if (typeof name !== 'string') return null;
    if (typeof email !== 'string') return null;
    return { mobileLocalDigits, name, email };
  } catch {
    return null;
  }
}

export function writeTradeInContactAnswers(data: TradeInContactAnswers): void {
  try {
    localStorage.setItem(TRADEIN_CONTACT_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearTradeInContactAnswers(): void {
  try {
    localStorage.removeItem(TRADEIN_CONTACT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
